import { useMutation, useQueryClient } from '@tanstack/react-query';
import taskTemplateService from '@services/taskTemplate';
import { toast } from 'react-toastify';
import { TASK_TEMPLATES_QUERY_KEY } from './useTaskTemplates';
import { useTranslation } from '@hooks/useTranslation';

export const useDeleteTaskTemplate = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['deleteTaskTemplate'],
    mutationFn: async (templateId: string) => {
      return await taskTemplateService.deleteTaskTemplate(templateId);
    },
    onSuccess: async () => {
      toast.success(tActionMessages.taskTemplateDeletedSuccessfully);
      await queryClient.invalidateQueries({ queryKey: [TASK_TEMPLATES_QUERY_KEY] });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message ||
          error?.message ||
          tActionMessages.failedToDeleteTaskTemplate,
      );
    },
  });
};

export default useDeleteTaskTemplate;
